import type { AppImageProps } from '@/app/components/media/app-image';
import type {
  BufferedImageLayer,
  BufferedImageLayers,
  SpartanProductCustomizeBufferedImageProps,
} from '@/app/lcv/components/sections/spartan/products/customize/configurator/preview-media/buffered-image/types';

export const getBufferedImageSourceKey = (src: AppImageProps['src']): string =>
  typeof src === 'string' ? src : String(src);

export const getBufferedImageLayerKey = (
  src: AppImageProps['src'],
  surfaceTone?: SpartanProductCustomizeBufferedImageProps['surfaceTone']
): string => `${getBufferedImageSourceKey(src)}:${surfaceTone ?? ''}`;

export const createBufferedImageLayer = (
  src: AppImageProps['src'],
  surfaceClassName?: string,
  surfaceTone?: SpartanProductCustomizeBufferedImageProps['surfaceTone']
): BufferedImageLayer => ({
  src,
  key: getBufferedImageLayerKey(src, surfaceTone),
  isReady: false,
  isFailed: false,
  surfaceClassName,
  surfaceTone,
});

export const decodeImage = (image: HTMLImageElement): Promise<void> => {
  if (typeof image.decode !== 'function') return Promise.resolve();

  try {
    return image.decode().catch(() => undefined);
  } catch {
    return Promise.resolve();
  }
};

export const setBufferedImageLayerSettled = (
  layers: BufferedImageLayers,
  index: number,
  key: string,
  isReady: boolean
): BufferedImageLayers => {
  const layer = layers[index];
  if (!layer || layer.key !== key) return layers;
  if (layer.isReady === isReady && layer.isFailed === !isReady) return layers;

  const nextLayers: BufferedImageLayers = [...layers];
  nextLayers[index] = {
    ...layer,
    isReady,
    isFailed: !isReady,
  };
  return nextLayers;
};
